module.exports = __webpack_public_path__ + "static/media/Assets-08-Visualising-epilepsy-01.a81fb64a.png";